import React from 'react';
import PropTypes from 'prop-types';
import ProgressSpinner
  from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';

export const CREDIT_LABEL = {
  ACCOUNT_CREDIT: 'Account Credit',
  EXISTING_SERVICE_CREDIT: 'Existing service credit',
};

function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
}

function ServicePlanOrderSummary({
  primaryServiceLabel,
  primaryServiceSubLabel,
  primaryServicePrice,
  onChangePlan,
  extraServiceLabel,
  extraServicePrice,
  creditLabel,
  creditAmount,
  subtotal,
  tax,
  isTaxLoading,
  onChangeTax,
  total,
}) {
  return (
    <div className="row">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className="col-form-label col-sm-3 text-sm-right align-self-start">
        <b>Order Summary</b>
      </label>
      <div className="col-sm-9">
        <div className="d-flex justify-content-between border-bottom py-1">
          <span>
            {primaryServiceLabel}
            {primaryServiceSubLabel && (
              <small className="text-muted ms-1">{primaryServiceSubLabel}</small>
            )}
            {' '}
            <button type="button" className="btn btn-link p-0 align-baseline" style={{ fontSize: 'inherit', textDecoration: 'underline' }} onClick={onChangePlan}>
              change
            </button>
          </span>
          <span>{formatCurrency(primaryServicePrice)}</span>
        </div>

        {extraServiceLabel != null && (
          <div className="d-flex justify-content-between border-bottom py-1">
            <span>{extraServiceLabel}</span>
            <span>{formatCurrency(extraServicePrice)}</span>
          </div>
        )}

        {creditLabel != null && (
          <div className="d-flex justify-content-between border-bottom py-1">
            <span>{creditLabel}</span>
            <span>
              -
              {formatCurrency(creditAmount)}
            </span>
          </div>
        )}

        <div className="d-flex justify-content-between border-bottom py-1">
          <span>Subtotal</span>
          <span>{formatCurrency(subtotal)}</span>
        </div>

        <div className="d-flex justify-content-between border-bottom py-1">
          <span>
            Tax
            {' '}
            <small className="text-muted" style={{ fontSize: '0.8em' }}>based on service address</small>
            {' '}
            <button type="button" className="btn btn-link p-0 align-baseline" style={{ fontSize: 'inherit', textDecoration: 'underline' }} onClick={onChangeTax}>
              change
            </button>
          </span>
          <span>
            {isTaxLoading ? (
              <ProgressSpinner progressText="" useSmallSpinner />
            ) : (
              formatCurrency(tax)
            )}
          </span>
        </div>

        <div className="d-flex justify-content-between border-bottom py-1">
          <b>Total Due</b>
          <b>
            <span>
              {isTaxLoading ? (
                <ProgressSpinner progressText="" useSmallSpinner />
              ) : (
                formatCurrency(total)
              )}
            </span>
          </b>
        </div>
      </div>
    </div>
  );
}

ServicePlanOrderSummary.propTypes = {
  primaryServiceLabel: PropTypes.string.isRequired,
  primaryServiceSubLabel: PropTypes.string,
  primaryServicePrice: PropTypes.number.isRequired,
  onChangePlan: PropTypes.func.isRequired,
  extraServiceLabel: PropTypes.string,
  extraServicePrice: PropTypes.number,
  creditLabel: PropTypes.string,
  creditAmount: PropTypes.number,
  subtotal: PropTypes.number.isRequired,
  tax: PropTypes.number.isRequired,
  isTaxLoading: PropTypes.bool.isRequired,
  onChangeTax: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
};
ServicePlanOrderSummary.defaultProps = {
  primaryServiceSubLabel: null,
  extraServiceLabel: null,
  extraServicePrice: null,
  creditLabel: null,
  creditAmount: null,
};

export default ServicePlanOrderSummary;
